import { IMainHeader } from "@/domain/main-header/entity/MainHeader.interface";
import { MainHeaderApplicationDataProvider } from "@/domain/main-header/application/MainHeaderApplicationData.provider";
import { ScriptSelector } from "@/domain/main-header/entity/ScriptSelector.enum";
import { MenuDTO } from "@/domain/main-header/dto";
import { EventsConfigurationProvider } from "@/domain/main-header/application/EventsConfiguration.provider";
import { MenuBuilder } from "@/domain/main-header/application/Menu.builder";

export class MenuConfigurationProvider {

    public static provideTo(applicationData: Partial<IMainHeader>, countryCode: string): Partial<IMainHeader> {

        if (!MainHeaderApplicationDataProvider.hasProvidedDataFor(ScriptSelector.MENU)) {
            return applicationData;
        }

        const menuDTO = MainHeaderApplicationDataProvider.parseProvidedData<MenuDTO>(ScriptSelector.MENU);

        if (!menuDTO) {
            return applicationData;
        }

        const localizedMenuDTO = menuDTO[countryCode];

        applicationData.menu = new MenuBuilder()
            .addEvents(EventsConfigurationProvider.getConfiguration())
            .addLocations(localizedMenuDTO)
            .addArtists(localizedMenuDTO)
            .addCustomTab(localizedMenuDTO)
            .build();

        return applicationData;
    }

}